import MuiTable, { TableProps as MuiTableProps } from '@mui/material/Table';

export type TableProps = MuiTableProps;

export const Table = (props: TableProps) => {
  return <MuiTable {...props} />;
};
